import { HttpClient } from '@reolink/web.fe.http-client';
import type { IAxiosRequestConfig, IHttpGetQs } from '@reolink/web.fe.http-client/dist/Common';
import * as CONFIG from '@/config';
interface IClientDataOptions {
    //是否接口响应数据直接返回data字段
    isReceivingResponseUseData?: boolean;
    isRPC?: boolean;
}

export const RawHttpClient = HttpClient;
// eslint-disable-next-line @typescript-eslint/no-redeclare

export class CustomHttpClient {
    protected readonly _httpInstance: HttpClient;

    public constructor(baseUrl: string, dataOptions?: IClientDataOptions) {
        //通过环境变量site来区分商户
        const httpClientConstructor = HttpClient;

        this._httpInstance = new httpClientConstructor({
            baseUrl: baseUrl,
            timeout: 20_000,
            configRequest: __isServerSide__
                ? {
                    onFulfilled(config) {
                        if (!config.headers) {
                            config.headers = {};
                        }
                        config.headers['origin'] = __MULTI_SITE_DEV_DOMAIN__
                            ? `https://${__MULTI_SITE_DEV_DOMAIN__}`
                            : CONFIG.OFFICIAL_DOMAIN;
                        return config;
                    },
                    onRejected(error) {
                        throw error;
                    },
                }
                : undefined,
            receivingResponse: {
                onFulfilled: (response) => {
                    if (dataOptions?.isReceivingResponseUseData) {
                        return response.data;
                    }
                    if (baseUrl.includes('apis')) {
                        return response;
                    }
                    if (baseUrl.includes('amazonaws.com')) {
                        return response;
                    }
                    if (baseUrl.includes('home-cdn.reolink.us')) {
                        return response;
                    }
                    if (response?.result?.code === 0) {
                        return response.data;
                    }
                    return Promise.reject(response);
                },
            },
        });
    }

    public get<T = void>(url: string, queryString?: IHttpGetQs, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.get(url, queryString, option);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async post<T = void>(
        url: string,
        body?: Record<string, unknown>,
        option?: IAxiosRequestConfig & { isSSR?: boolean; },
    ): Promise<T> {
        return this._httpInstance.post(url, body, option);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public put<T = void>(url: string, body?: Record<string, any>, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.put(url, body, option);
    }

    public delete<T = void>(url: string, queryString?: IHttpGetQs, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.delete(url, queryString, option);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public patch<T = any>(url: string, body?: Record<string, unknown>, option?: IAxiosRequestConfig): Promise<T> {
        return this._httpInstance.patch(url, body, option);
    }
}

export const client = new CustomHttpClient(`${CONFIG.OFFICIAL_DOMAIN}/wp-json/reo-v2`);
export const clientApisV2 = new CustomHttpClient(`${CONFIG.baseUrlApiV2}`);
export const officialServerClient = new CustomHttpClient(`${CONFIG.baseUrlApiV2}/official-site-data-cache`);
